/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {disableSuperstacking} from '../api'

export const useMutationDisableSuperstacking = createReactQueryMutationHook('disableSuperstacking', disableSuperstacking)
